import React, { FC } from "react"
import { connect } from "react-redux"
import { RootState } from "../../../store/reducers"

const UploadsModal: FC<{
  uploading: any
}> = ({ uploading }) => {
  return (
    <div id="uploads-modal" className="uk-flex-top" data-uk-modal>
      <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <button
          className="uk-modal-close-default"
          type="button"
          data-uk-close
        ></button>

        <div className="uk-modal-header">
          <h2 className="uk-modal-title">Uploads</h2>
        </div>
        <div className="uk-modal-body">
          <ul className="uk-list uk-list-striped">
            <li>
              {uploading ? (
                <div>
                  <div>{uploading.title}</div>
                  <progress
                    // min={0}
                    max={100}
                    className="uk-progress"
                    value={uploading.progress}
                  ></progress>
                </div>
              ) : (
                <span>You have no uploads running</span>
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

const mapState = (state: RootState) => ({
  uploading: state.data.uploading,
})

export default connect(mapState)(UploadsModal)
